<template>
  <div>
    <b-input-group>
      <b-form-input
        size="sm"
        :state="state"
        :disabled="isDisabled"
        v-model="query"
        placeholder="Выберите объект"
        autocomplete="off"
        @focus="onFocusIn"
        @blur="onFocusOut"
      />

      <b-input-group-append>
        <b-button size="sm" :disabled="!query || this.$props.isDisabled" @click="onClear">
          <font-awesome-icon icon="times-circle"/>
        </b-button>
      </b-input-group-append>

      <b-list-group class="autocomplete-input-location" v-if="isFocus" :class="{ 'dropUp': dropUp }">
        <b-list-group-item v-for="(item, index) in items" :key="index" @mousedown="onClick(item)" button class="text-small">
          <div>{{ item.name }}</div>
          <div class="text-secondary">Заказчик: {{item.customer_name}} | Город: {{item.town_name}}</div>
          <div v-if="item.address" class="text-secondary">Адрес: {{item.address}}</div>
        </b-list-group-item>
        <b-list-group-item v-if="items.length === 0" disabled>
          <small>Ничего не найдено</small>
        </b-list-group-item>
      </b-list-group>
    </b-input-group>
  </div>
</template>

<script>
import locations from "../../network/locations";

export default {
  name: "LocationSelect",
  mixins: [ locations ],
  props: {
    isDisabled: Boolean,
    value: { type: Number, default: null },
    initialText: { type: String, default: '' },
    state: { type: Boolean, default: null },
    dropUp: { type: Boolean, default: false }
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
      worker_id: 0,
    }
  },
  methods: {
    async configure(id, worker_id) {
      if (worker_id != null) {
        this.worker_id = worker_id;
      }

      if (id > 0) {
        const result = await this.getLocationById(id);

        if (result && result.data) {
          this.query = result.data.name;
          return;
        }
      }

      this.query = "";
      this.items = await this.getItems();
    },
    onFocusIn() {
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;
    },
    onClear() {
      this.query = "";
      this.$emit('onSelect', 0, null);
    },
    onClick(item) {
      this.query = item.name;
      this.$emit('onSelect', item.id, item);
    },
    async getItems() {
      const data = {
        page: 1,
        size: 400,
        query: this.query.toLowerCase(),
        payment_type_int: -1,
        exept_worker_id: this.worker_id
      }

      const result = await this.getLocationsSearch(data);
      return (result && result.data) ? result.data.items : [];
    },
  },
  watch: {
    'query': {
      handler: async function () {
        if (this.query != null) {
          this.items = await this.getItems();
        }
      }, deep: true, immediate: true
    },
    initialText: {
      handler(newValue) {
        if (this.value && !this.query && newValue) {
          this.query = newValue;
        }
      }, immediate: true
    },
  }
}
</script>

<style>
.autocomplete-input-location {
  max-height: 250px;
  margin-top: 31px;
  min-width: 100%;
  overflow-y: auto;
  position: absolute;
  z-index: 1060;
  top: 0;
}

.autocomplete-input-location .list-group-item {
  padding: 0.5rem 1rem;
}

.autocomplete-input-location.dropUp {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationSelect.vue